<nz-collapse [nzBordered]="false" nzGhost>
  <nz-collapse-panel
    #invalidPanel
    class="collapse-panel"
    [nzHeader]="'page.timeline.kpi.stay_list.invalid_stays' | translate"
    [nzActive]="true"
    [nzShowArrow]="false"
    [nzExtra]="invalidStaysCollapseIcon"
  >
    <div class="card-container">
      @if (!isLoadingInvalidStays) {
        @for (stay of invalidStays; track stay) {
          <wilson-drawer-stay-card
            [stayId]="stay.id"
            [userId]="stay.userId"
            [userName]="
              stay.user ? stay.user.lastName + ', ' + stay.user.firstName : ''
            "
            [locationName]="stay.location | locationName"
            [date]="stay.startDatetime"
            [cancellationDate]="stay.cancellationDate"
            (openStayDrawer)="openEditStaysDrawer(stay)"
            (closeDrawer)="closeDrawer.emit()"
            (navigateToTimeline)="
              navigateToTimeline(stay.id, null, stay.userId, stay.startDatetime)
            "
          ></wilson-drawer-stay-card>
        }
      } @else {
        <nz-skeleton
          [nzActive]="true"
          [nzTitle]="false"
          [nzParagraph]="{ rows: 4 }"
        ></nz-skeleton>
      }
    </div>
  </nz-collapse-panel>
  <ng-template #invalidStaysCollapseIcon>
    <fa-icon
      [icon]="invalidPanel.nzActive ? faChevronUp : faChevronDown"
    ></fa-icon>
  </ng-template>
</nz-collapse>

<nz-collapse [nzBordered]="false" nzGhost class="mt-3">
  <nz-collapse-panel
    #necessaryPanel
    class="collapse-panel"
    [nzHeader]="'page.timeline.kpi.stay_list.necessary_stays' | translate"
    [nzActive]="true"
    [nzShowArrow]="false"
    [nzExtra]="necessaryStaysCollapseIcon"
  >
    <div class="card-container">
      @if (!isLoadingNecessaryStays) {
        @for (stay of necessaryStays; track stay) {
          <wilson-drawer-stay-card
            [userId]="stay.userId"
            [userName]="stay.userName"
            [locationName]="stay.locationName"
            [date]="stay.date"
            (openStayDrawer)="openCreateStaysDrawer(stay)"
            (closeDrawer)="closeDrawer.emit()"
            (navigateToTimeline)="
              navigateToTimeline(null, stay.shift, stay.userId, stay.date)
            "
          ></wilson-drawer-stay-card>
        }
      } @else {
        <nz-skeleton
          [nzActive]="true"
          [nzTitle]="false"
          [nzParagraph]="{ rows: 4 }"
        ></nz-skeleton>
      }
    </div>
  </nz-collapse-panel>
  <ng-template #necessaryStaysCollapseIcon>
    <fa-icon
      [icon]="necessaryPanel.nzActive ? faChevronUp : faChevronDown"
    ></fa-icon>
  </ng-template>
</nz-collapse>
